import requestAction from '../../utils/requestAction'

export const fetchProductSubgroup = (productSubgroupId: string) =>
  requestAction('PRODUCTSUBGROUP_DETAIL')(`productSubgroups/${productSubgroupId}`, 'GET')
